export const signUpCallback = (): void => {
  const event = new CustomEvent('sign-up', { detail: { source: 'react' } })
  document.dispatchEvent(event)
}
